import { useCreatorCashContext } from '../../../context/CreatorCashProvider';
import { creators } from '../../../utils/constants';
import FadeInSection from '../../FadeInComponent/FadeInComponent';
import ApplyNow from '../ApplyNow/ApplyNow';
import './Creators.css';

export default function Creators({ scrollToRef }) {

    const { state } = useCreatorCashContext();
    const creatorContent = state?.creatorsSection;
    const variant = state?.variant;

    return (
        <div className='creators-container'>
            <FadeInSection>
                <div className="creators-heading">
                    <div className="creators-title">
                        {
                            creatorContent?.title?.map((title, index) =>
                                <span key={index} className={`${title?.isUpperCase ? 'uppercase' : 'capitalize'} ${title?.isInGreen ? 'text-green' : 'text-white'}`}>{title?.value}</span>
                            )
                        }
                    </div>
                    <div className="creators-sub-title">{creatorContent?.subTitle}</div>
                </div>
            </FadeInSection>
            {
                variant === "a" ? (
                    <div className='creators-card-container'>
                        {
                            creatorContent?.profile?.map((creator, index) => (
                                <div
                                    key={index}
                                    className='creators-card'
                                    style={{
                                        background: `url("${creators[index]}") no-repeat center / cover`,
                                    }}
                                >
                                    <div className='creators-card-content'>
                                        <div className={`creators-card-content-title ${creator?.title?.isUpperCase ? 'uppercase' : 'capitalize'}`}>{creator?.title?.value}</div>
                                        <div className="creators-card-content-sub-title">{creator.subTitle}</div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                ) : (
                    <div className="creators-card-container-v2">
                        {
                            creatorContent?.profile?.map((creator, index) => {
                                const isLeft = ((index + 1) % 2) !== 0;
                                return (
                                    <div key={index} className={`creators-card-v2 ${isLeft ? 'flex-row' : 'flex-row-reverse'}`}>
                                        <img
                                            src={creators[index]}
                                            key={index}
                                            className={"creators-card-image-v2"}
                                            alt='card'
                                            {
                                            ...(variant !== "a" && {
                                                style: {
                                                    boxShadow: `${!isLeft ? '-12px' : '12px'} 4px 20px 1px #00000033`,
                                                }
                                            })
                                            }
                                        />

                                        <div className={`creators-card-content-v2 ${isLeft ? 'left left-[500px] px-[112px] py-[61px]' : 'right right-[500px] pt-[61px] pr-[124px] pb-[61px] pl-[64px]'}`}>
                                            <div className={`creators-card-content-title-v2 ${creator?.title?.isUpperCase ? 'uppercase' : 'capitalize'}`}>{creator?.title?.value}</div>
                                            <div className="creators-card-content-sub-title-v2">{creator.subTitle}</div>
                                            {creator?.showApplyNowButton && <ApplyNow label={index % 2 !== 0 ? "Check Eligibility" : "See If You Qualify"} className="apply-now-v2" onClick={scrollToRef} />}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        </div>
    )
}